import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import axiosInstance from "../../../configs/axios/axios ";
import { GET_SUB_REPORTS } from "../../../configs/axios/constantsAPI";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";

export const getSubReportsListAction = createAsyncThunk(
  "subReportsModal/getSubReportsList",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        GET_SUB_REPORTS,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );
      
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface Items {
  id: string;
  uniq_id: string;
  name: string;
  ip: string;
  link: string;
  nameShareFile: string;
  download: string;
  status: string;
  timestamp: string;
}

export interface SubReportsModalState {
  openModal: boolean;
  subReportsUniqId: string;
  subReportsData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    list: Array<Items>;
  };
}

const initialState: SubReportsModalState = {
  openModal: false,
  subReportsUniqId: "",
  subReportsData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    list: [],
  },
};

export const subReportsModalSlice = createSlice({
  name: "subReportsModal",
  initialState,
  reducers: {
    subReportsModalOpenAction: (state) => {
      state.openModal = true;
    },
    subReportsModalCloseAction: (state) => {
      state.openModal = false;
      state.subReportsUniqId = initialState.subReportsUniqId;
      state.subReportsData = initialState.subReportsData;
    },
    setSubReportsUniqIdAction: (state, action: PayloadAction<string>) => {
      state.subReportsUniqId = action.payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getSubReportsListAction.pending, (state) => {
      state.subReportsData.actionStatus = "loading";
      state.subReportsData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getSubReportsListAction.fulfilled, (state, { payload }) => {
      state.subReportsData.actionStatus = "success";
      state.subReportsData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.subReportsData.list = payload.content?.data;
    });
    addCase(getSubReportsListAction.rejected, (state, { payload }: any) => {
      state.subReportsData.actionStatus = "rejected";
      state.subReportsData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const {
  subReportsModalOpenAction,
  subReportsModalCloseAction,
  setSubReportsUniqIdAction,
} = subReportsModalSlice.actions;

export const subReportsModal = (state: RootState) => state.subReportsModalState;

export default subReportsModalSlice.reducer;
